import React from 'react';
import { Button, Modal } from 'antd';
import BookInfo from './BookInfo';

function BookDetailModal({ isModalOpen, handleCancel, id }) {
  return (
    <Modal
      title="Thông tin sách"
      open={isModalOpen}
      onCancel={handleCancel}
      width={1100}
      footer={[
        <Button key="return" onClick={handleCancel}>
          Thoát
        </Button>,
      ]}
    >
      <BookInfo id={id} />
    </Modal>
  );
}

export default BookDetailModal;
